/**
* DevExpress Analytics (query-builder\wizard\internal\_wizardAction.js)
* Version:  20.2.9
* Build date: Aug 16, 2021
* Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ko = require("knockout");
var WizardAction = (function () {
    function WizardAction(handler, text) {
        this.handler = handler;
        this.isVisible = ko.observable(true);
        this.isDisabled = ko.observable(false);
        this.text = text;
    }
    return WizardAction;
}());
exports.WizardAction = WizardAction;
